<template>
    <div>
        <div class="mt-32">
            <subject-text class="subject-text mb-24" text="결제수단 선택"></subject-text>
            <div class="flex-y-center mb-24">
                <label class="radiobox">
                    <input type="radio" name="payment" value="card" checked/>
                    <span class="image-tosspay"></span>
                    <span class="pay-text">카드</span>
                </label>
            </div>
        </div>
        <div class="paycard">
            <!-- <div class="paycard-wrap bg-yellow">
                <span class="image-samsung-card"></span>
                <div>
                    <span class="card-name">삼성카드</span>
                    <span class="card-number">1234 56** **** 7890</span>
                </div>
            </div> -->
            <payment-card :slide-data="cardList"></payment-card>
        </div>
        <div class="mt-40">
            <div class="flex-y-center mb-20">
                <label class="radiobox">
                    <input type="radio" name="payment" value="account" />
                    <span class="image-tosspay"></span>
                    <span class="pay-text">계좌이체</span>
                </label>
            </div>
            <div class="flex-y-center mb-34">
                <label class="radiobox">
                    <input type="radio" name="payment" value="general"/>
                    <span class="pay-text ml-8">일반결제</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import SubjectText from '@/components/common/SubjectText.vue';
import PaymentCard from '@/components/common/PaymentCard.vue'

export default {
    name: 'SelectPayment',
    components: { SubjectText, PaymentCard },
    data() {
        return {
            cardList: [
                { id: 'card1', cardImg: require("/src/assets/images/products/card1.png") },
                { id: 'card2', cardImg: require("/src/assets/images/products/card2.png") },
                { id: 'card3', cardImg: require("/src/assets/images/products/card1.png") },
                { id: 'card4', cardImg: require("/src/assets/images/products/card2.png") },
            ],
        }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/selectPayment.scss';
</style>